module.exports = {
  // apiUrl: "http://localhost:4023",
  // apiUrl: "https://test-console-api.xpertdox.com",
  apiUrl: "https://console-api.xpertdox.com",
  // localUrl: 'http://localhost:4003',
  // localUrl: "https://testconsole.xpertdox.com",
  localUrl: 'https://console.xperttrial.com',
  ssoApi: 'https://sso.xpertdox.com',
  ssoUrl: 'https://accounts.xpertdox.com/sso',
  // ssoApi: 'http://localhost:4002',
  // ssoUrl: 'http://localhost:3001/sso',
  // ssoApi: 'https://test-sso.xpertdox.com',
  // ssoUrl: 'https://test-accounts.xpertdox.com/sso',
  auth: {
    headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Authorization": "Bearer 3ecd8fae-a11c-4561-9d53-824148b2fb13"
    }
  },
  token: "Bearer 3ecd8fae-a11c-4561-9d53-824148b2fb13"
}